import { render, staticRenderFns } from "./PaymentsAdminView.vue?vue&type=template&id=32f83bec&scoped=true"
import script from "./PaymentsAdminView.vue?vue&type=script&lang=js"
export * from "./PaymentsAdminView.vue?vue&type=script&lang=js"
import style0 from "./PaymentsAdminView.vue?vue&type=style&index=0&id=32f83bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f83bec",
  null
  
)

export default component.exports